export const stok = [
    // {
    //   'sFlash' :'Yeni*',
    //   'nStokID':'17',
    //   'sKodu': 'PoindusPos310',
    //   'sAciklama': 'Poindus VariPos 310',
    //   'sSinifKodu' : 'POS',
    //   'sDovizCinsi' :'USD',
    //   'nKdvOrani' : 18,
    //   'lEskiFiyat' :'',
    //   'lFiyat1' : 1190,
    //   'lFiyat2' : 1290,
    //   'lFiyat3' : 1390,
    //   'pResim' :require('@/assets/img/shop/17.png'),
    //   'sDetail' : ' <li><i class="icon-caret-right"></i> Düşük güç tüketimi, Intel Bay Trail-T CR Z3735F işlemci</li><li><i class="icon-caret-right"></i> 10.1 / 14 inch Gerçek Düz P-CAP dokunmatik ekran</li><li><i class="icon-caret-right"></i> IP54 su geçirmezlik</li><li><i class="icon-caret-right"></i> Gelişmiş işlevsellik, fiş yazıcısı. MSR, Entegre iButton</li><li><i class="icon-caret-right"></i> Android / Windos OS u Sorunsuz entegrasyon için destekler</li>',
    //   'sStar' : 'Diamond',
    //   'bPopular' : false,
    //   'bAktif' : true,
    //   'rating':5,
    //   'free_shipping':true

    // },
    // {
    //   'sFlash' :'Yeni*',
    //   'nStokID':'18',
    //   'sKodu': 'PoindusPos210',
    //   'sAciklama': 'Poindus VariPos 210',
    //   'sSinifKodu' : 'POS',
    //   'sDovizCinsi' :'USD',
    //   'nKdvOrani' : 18,
    //   'lEskiFiyat' :'',
    //   'lFiyat1' : 990,
    //   'lFiyat2' : 1290,
    //   'lFiyat3' : 1290,
    //   'pResim' :require('@/assets/img/shop/18.png'),
    //   'sDetail' : '<li><i class="icon-caret-right"></i> Düşük Güç Tüketimi Intel Bay Trail-T CR Z3735F Dört Çekirdekli İşlemci</li><li><i class="icon-caret-right"></i> 14 "16: 9 Gerçek Düz Geniş P-Cap Dokunmatik Ekran</li><li><i class="icon-caret-right"></i> tüm perakende çevre birimleri için Powered USB bağlantıları </li><li><i class="icon-caret-right"></i> Harici Güç Bankası ile kesintisiz hizmet 4 saat Desteklenmesi ile taşınabilir hafif, (16,000mAh ile)</li><li><i class="icon-caret-right"></i> Die-Cast alüminyum kasa şık modern tasarımı ile</li><li><i class="icon-caret-right"></i> Sağlam yapı: Die-Cast Alüminyum destek ve koruma için sağlam, ağır çerçevesi sağlar</li><li><i class="icon-caret-right"></i> VariPAD S olarak 2 Ekran oyunculuk ya da tek başına Tablet Standı ile Tamamlayıcı </li><li><i class="icon-caret-right"></i> Özel Şirket Markası mevcut</li> ',
    //   'sStar' : 'Platinum',
    //   'bPopular' : false,
    //   'bAktif' : true,
    //   'rating':5,
    //   'free_shipping':true
    // },
    // {
    //   'sFlash' :'Yeni*',
    //   'nStokID':'50',
    //   'sKodu': 'Pico360',
    //   'sAciklama': 'DIGI IPT-360 PICO',
    //   'sSinifKodu' : 'POS',
    //   'sDovizCinsi' :'USD',
    //   'nKdvOrani' : 8,
    //   'lEskiFiyat' :'',
    //   'lFiyat1' : 1950,
    //   'lFiyat2' : 1950,
    //   'lFiyat3' : 1950,
    //   'pResim' :require('@/assets/img/shop/50.png'),
    //   'sDetail' : '<li><i class="icon-caret-right"></i> DIGI IPT-360 PICO Yeni Nesil Ödeme Kaydedici Cihaz (YNÖKC), hem fiş, Bildiğiniz Marka Artık Yeni Nesil Yazar Kasa.</li><li><i class="icon-caret-right"></i> PICO yazarkasa barkod okuycu, terazi, para çekmecesi, PC, faturayazıcısı, manyetik kart okuyucu gibi perakende sektöründe kullanılançevre birim bağlantılarını hiçbir arabirime gerek duymadan doğrudandesteklemektedir.</li><li><i class="icon-caret-right"></i> EFT-POS Bağlantısı PICO yazarkasanın EFT-POS bağlantısı Tübitak tarafındanonaylanmıştır. EFT-POS bağlantısı yapıldığında kredi kartı slibi fiş ileberaber yazarkasadan basılır. Tek tuş ile kredili satış yapmanızı sağlar.</li><li><i class="icon-caret-right"></i> Restoranlar İçinUçtan Uca Çözüm* Mutfak yazıcısı, mutfak ekranı, garson terminali, sıra göstergesi veAndroid el terminali ile restoranlarda mutfaktan-müşteriye kadar tümsüreçleri otomasyon ile yürütebilirsiniz.</li>',
    //   'sStar' : 'Platinum',
    //   'bPopular' : false,
    //   'bAktif' : true,
    //   'rating': 5,
    //   'free_shipping':true
    // },
    // {
    //   'sFlash' :'',
    //   'nStokID':'3',
    //   'sKodu': 'Toshiba4610',
    //   'sAciklama': 'Toshiba/IBM 4610-2NF Yeni Nesil Pos',
    //   'sSinifKodu' : 'POS',
    //   'sDovizCinsi' :'USD',
    //   'nKdvOrani' : 18,
    //   'lEskiFiyat' :'',
    //   'lFiyat1' : 3150,
    //   'lFiyat2' : 3150,
    //   'lFiyat3' : 3150,
    //   'pResim' :require('@/assets/img/shop/3.png'),
    //   'sDetail' : '<li><i class="icon-caret-right"></i> Toshiba 4610-2NF Yeni Nesil Ödeme Kaydedici Cihaz (YNÖKC), hem fiş, hem de belge düzenleyen çift istasyonlu yazıcısı ile perakende ortamları için ideal ve üstün performansa sahip yeni nesil yazar kasadır.</li><li><i class="icon-caret-right"></i> Olağanüstü baskı hızı ve yeni nesil yazarkasa gereksinimlerine uygun tasarımı ile işinizi kesintisiz ve daha hızlı yapmanızı sağlar.</li><li><i class="icon-caret-right"></i> Mağaza/market ortamlarının çalışma koşullarına uygun Toshiba 4610-2NF YNÖKC , dayanıklığı kanıtlanmış yüksek güvenirlikli yazıcısı, programlanabilir 67 tuşlu POS klavyesi ve çift yüzlü ekranı ile ödeme noktanızda dağınık düzende kullanım seçeneği de sunmaktadır.</li><li><i class="icon-caret-right"></i> Uzun ömürlü Toshiba 4610-2NF YNÖKC, hızlı bir ödeme noktası olmanın yanında, mağazanızda müşteri memnuniyetinizi artırıcı, müşteri ilişkileri noktanız olacaktır.</li>',
    //   'sStar' : 'Diamond',
    //   'bPopular' : false,
    //   'bAktif' : true,
    //   'rating': 4,
    //   'free_shipping':true
    // },
    {
      'sFlash' :'Kampanya*',
      'nStokID':'4',
      'sKodu': 'YN200',
      'sAciklama': 'ENPos YN-200 Yeni Nesil Pos',
      'sSinifKodu' : 'POS',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 8,
      'lEskiFiyat' :'',
      'lFiyat1' : 2990,
      'lFiyat2' : 2990,
      'lFiyat3' : 2990,
      'pResim' :require('@/assets/img/shop/4.png'),
      'sDetail' : '<li><i class="ico <li><i class="icon-caret-right"></i> İnter N-POS YN200 Yeni Nesil Ödeme Kaydedici Cihaz (YNÖKC), hem fiş, hem de belge düzenleyen çift istasyonlu yazıcısı ile perakende ortamları için uygun fiyat ve performansa sahip yeni nesil yazar kasadır.</li><li><i class="icon-caret-right"></i> Olağanüstü baskı hızı ve yeni nesil yazarkasa gereksinimlerine uygun tasarımı ile işinizi kesintisiz ve daha hızlı yapmanızı sağlar.</li><li><i class="icon-caret-right"></i> Mağaza/market ortamlarının çalışma koşullarına uygun İnter N-POS YN200 YNÖKC , performansı kanıtlanmış yüksek güvenirlikli yazıcısı, programlanabilir POS klavyesi,Satış Ekranı ve çift yüzlü müşteri göstergesi ile ödeme noktanızda dağınık düzende kullanım seçeneği de sunmaktadır.</li><li><i class="icon-caret-right"></i> İnter N-POS YN200 YNÖKC, hızlı bir ödeme noktası olmanın yanında, mağazanızda müşteri memnuniyetinizi artırıcı, müşteri ilişkileri noktanız olacaktır.</li>n-caret-right"></i> Toshiba 4610-2NF Yeni Nesil Ödeme Kaydedici Cihaz (YNÖKC), hem fiş, hem de belge düzenleyen çift istasyonlu yazıcısı ile perakende ortamları için ideal ve üstün performansa sahip yeni nesil yazar kasadır.</li><li><i class="icon-caret-right"></i> Olağanüstü baskı hızı ve yeni nesil yazarkasa gereksinimlerine uygun tasarımı ile işinizi kesintisiz ve daha hızlı yapmanızı sağlar.</li><li><i class="icon-caret-right"></i> Mağaza/market ortamlarının çalışma koşullarına uygun Toshiba 4610-2NF YNÖKC , dayanıklığı kanıtlanmış yüksek güvenirlikli yazıcısı, programlanabilir 67 tuşlu POS klavyesi ve çift yüzlü ekranı ile ödeme noktanızda dağınık düzende kullanım seçeneği de sunmaktadır.</li><li><i class="icon-caret-right"></i> Uzun ömürlü Toshiba 4610-2NF YNÖKC, hızlı bir ödeme noktası olmanın yanında, mağazanızda müşteri memnuniyetinizi artırıcı, müşteri ilişkileri noktanız olacaktır.</li>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'Kampanya*',
      'nStokID':'59',
      'sKodu': 'YN500',
      'sAciklama': 'ENPos YN-500 Yeni Nesil ÖKC',
      'sSinifKodu' : 'POS',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 8,
      'lEskiFiyat' :'',
      'lFiyat1' : 1590,
      'lFiyat2' : 1590,
      'lFiyat3' : 1590,
      'pResim' :require('@/assets/img/shop/59.png'),
      'sDetail' : '<ul><li>Dayanıklı, s&uuml;rd&uuml;r&uuml;lebilir</li><li>Hızlı yazıcı</li><li>Hafif ve az yer kaplayan</li><li>Farklı satış yazılımlarıyla &ccedil;alışabilme</li><li>e-Arşiv Fatura d&uuml;zenleyebilme</li><li>Ingenico Imp PRO &amp; Verifone D10 Entegrasyonu​​​​​​​</li></ul>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
   
    {
      'sFlash' :'İndirimli!',
      'nStokID':'5',
      'sKodu': 'DokunmatikPc',
      'sAciklama': 'Dokunmatik Pc',
      'sSinifKodu' : 'POS',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :690,
      'lFiyat1' : 590,
      'lFiyat2' : 590,
      'lFiyat3' : 590,
      'pResim' :require('@/assets/img/shop/5.png'),
      'sDetail' : '<li><i class="icon-caret-right"></i> Intel Celeron 1037U 1.8Ghz (Dual Core)</li><li><i class="icon-caret-right"></i> Kingston 2 GB DDR 3 Ram</li><li><i class="icon-caret-right"></i> 60 GB Ssd Hard Disk</li><li><i class="icon-caret-right"></i> 5 Wire Resitive Touch Screen</li><li><i class="icon-caret-right"></i> 15" LED Touch Panel</li><li><i class="icon-caret-right"></i> 6 Adet Usb Girişi</li><li><i class="icon-caret-right"></i> 4 Adet Com Girişi</li><li><i class="icon-caret-right"></i> 1 Adet HDMI Çıkış </li><li><i class="icon-caret-right"></i> 1 Adet VGA Çıkış </li><li><i class="icon-caret-right"></i> Çözünürlük 1024x768</li>',
      'sStar' : 'Platinum',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'6',
      'sKodu': 'ThermalFisYazici',
      'sAciklama': 'Thermal Fiş Yazıcı',
      'sSinifKodu' : 'printer',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 129,
      'lFiyat2' : 129,
      'lFiyat3' : 129,
      'pResim' :require('@/assets/img/shop/6.png'),
      'sDetail' : '<li><i class="icon-caret-right"></i> Ürün POSCLASS ZJ-8260</li><li><i class="icon-caret-right"></i> Çözünürlük 203 Dbi</li><li><i class="icon-caret-right"></i> Baskı Genişliği 79.5 ± 0.5mm</li><li><i class="icon-caret-right"></i> Baskı Hızı 300 mm/sn</li><li><i class="icon-caret-right"></i> Sütün Sayısı 42/58 Kolon</li><li><i class="icon-caret-right"></i> Kesici Oto. Kesme/Kısmi Kesme(1 Milyon Kesme Ömrü)</li><li><i class="icon-caret-right"></i> Arabirim USB+ETH+SERI</li><li><i class="icon-caret-right"></i> Barkod Desteği UPC-A/UPC-E/JAN13(EAN13)/JAN8(EAN8) CODABAR/ITF/CODE39/CODE93/CODE12</li><li><i class="icon-caret-right"></i> Rulo Kâğıt Genişliği 80 mm</li><li><i class="icon-caret-right"></i> Sensör Uyarı/Kağıt Bitti/Kapak Açık Vb.</li><li><i class="icon-caret-right"></i> Elektrik Besleme 24V DC</li><li><i class="icon-caret-right"></i> İşletim Sistemi Xp/Windows 7/Windows 8/Server İşletim Sis.(2003-2008-2012)</li><li><i class="icon-caret-right"></i> Askı Desteği Duvar Askı Aparatı </li><li><i class="icon-caret-right"></i> Çalışma Sıcaklığı 0-45 °C</li><li><i class="icon-caret-right"></i> Garanti 2 YIL</li>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'7',
      'sKodu': 'LaserBarkodOkuyucu',
      'sAciklama': 'Laser Barkod Okuyucu',
      'sSinifKodu' : 'scanner',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 80,
      'lFiyat2' : 80,
      'lFiyat3' : 80,
      'pResim' :require('@/assets/img/shop/7.png'),
      'sDetail' : '<li><i class="icon-caret-right"></i> Teknoloji Lazer</li><li><i class="icon-caret-right"></i> Işık Kaynağı 645nm - 660 Görülebilir Lazer Diyot</li><li><i class="icon-caret-right"></i> Renk Göstergeleri Renkli LED gösterge (Yeşil=Tarama/Kırmızı=Doğru Okuma)</li><li><i class="icon-caret-right"></i> Okuma Derinliği 60 cm</li><li><i class="icon-caret-right"></i> Tarama Hızı 200 Tarama/sn</li><li><i class="icon-caret-right"></i> Bar Genişliği 1.25 mm (5 Mils)</li><li><i class="icon-caret-right"></i> Kontrast %35@UP / EAN %100</li><li><i class="icon-caret-right"></i> Uyarı Şekli Ses ve Işık / LED sinyalizasyonu</li><li><i class="icon-caret-right"></i> Kablo Uzunluğu 2 metre düz</li><li><i class="icon-caret-right"></i> Bağlantı USB, RS232, Klavye, USB-SERIAL</li><li><i class="icon-caret-right"></i> Okuna Bilir Barkod Türleri UPC-A,UPC-E,EAN13,EAN-8,ISBN/ISSN, Code 39 full ASCII, China Post, Intel leaved 2 of 5, Industry 2 of 5, Matrix 2 of 5, Codabar, Code128, Code 93, Code 11( usd-8 ), MSI Plessey, UK/Plessey , UCC/EAN 128</li><li><i class="icon-caret-right"></i> Toz-Su Koruma IP52</li><li><i class="icon-caret-right"></i> Okuma Açısı Yatay 55°</li><li><i class="icon-caret-right"></i> Düşme Dayanımı 1.5m Yükseklikten Beton Zemine</li><li><i class="icon-caret-right"></i> Okuma Şekli Barkod okuyucu elde tetikli, standında otomatik algılama</li>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'İndirimli',
      'nStokID':'8',
      'sKodu': 'cekmece',
      'sAciklama': 'Para Çekmecesi',
      'sSinifKodu' : 'other',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :120,
      'lFiyat1' : 90,
      'lFiyat2' : 90,
      'lFiyat3' : 90,
      'pResim' :require('@/assets/img/shop/8.png'),
      'sDetail' : '<li><i class="icon-caret-right"></i> Kağıt Para Haznesi 4 Bölmeli Kağıt Para Haznesi</li><li><i class="icon-caret-right"></i> Bozuk Para Haznesi 8 Bölmeli Bozuk Para Haznesi Çekmecenin Kolay Açmasını Sağlayan Kulplar</li><li><i class="icon-caret-right"></i> Boyutlar 410 X 420 X 100 mm</li><li><i class="icon-caret-right"></i> Teleskopik Raylı </li><li><i class="icon-caret-right"></i> Termal Yazıcı Cash Sürücü Desteği</li>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
   
    {
      'sFlash' :'',
      'nStokID':'12',
      'sKodu': 'Datamax4205',
      'sAciklama': 'Datamax 4205 Barkod Yazıcı',
      'sSinifKodu' : 'printer',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 495,
      'lFiyat2' : 495,
      'lFiyat3' : 495,
      'pResim' :require('@/assets/img/shop/12.png'),
      'sDetail' : ' <li><i class="icon-caret-right"></i> Özellik Datamax E - 4205</li><li><i class="icon-caret-right"></i> Baskı Metodu Direkt Termal / Termal Transfer</li><li><i class="icon-caret-right"></i> Baskı hızı 5ips (127mm/s)</li><li><i class="icon-caret-right"></i> Baskı genişliği 4.25” (108 mm)</li><li><i class="icon-caret-right"></i> Baskı uzunluğu 0.375” - 99” (9.5mm - 2514mm)</li><li><i class="icon-caret-right"></i> Çözünürlük 203 dpi</li><li><i class="icon-caret-right"></i> Ribon Genişliği 5.0” (127 mm) O.D.</li><li><i class="icon-caret-right"></i> Hafıza RAM 64MB Flash</li><li><i class="icon-caret-right"></i> Flash ROM 16MB DRAM</li><li><i class="icon-caret-right"></i> Arayüz USB 2.0, Seri RS232, Paralel, 10/100 Base T Ethernet</li><li><i class="icon-caret-right"></i> Arayüz Opsiyonel wi-fi, bluetooth</li><li><i class="icon-caret-right"></i> Dil PL-Z, PL-B , PL-I , PL-E</li>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'13',
      'sKodu': 'MasaüstüBarkodOkuyucu',
      'sAciklama': 'Masaüstü Barkod Okuyucu',
      'sSinifKodu' : 'scanner',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 190,
      'lFiyat2' : 190,
      'lFiyat3' : 190,
      'pResim' :require('@/assets/img/shop/13.png'),
      'sDetail' : '<li><i class="icon-caret-right"></i> Teknoloji Lazer</li><li><i class="icon-caret-right"></i> Işık Kaynağı 650 nm Görülebilir Lazer Diyot</li><li><i class="icon-caret-right"></i> Renk Göstergeleri İki renkli LED (mavi - kırmızı)</li><li><i class="icon-caret-right"></i> Ağırlık (Kablosuz) 574.5 gr (kablosuz)</li><li><i class="icon-caret-right"></i> Okuma Derinliği 0~200 mm</li><li><i class="icon-caret-right"></i> Tarama Hızı 2600 tarama / s</li><li><i class="icon-caret-right"></i> Bar Genişliği 5 mil @ PSC %90</li><li><i class="icon-caret-right"></i> Okuma Sesi Ayarlanabilir ses ve zaman</li><li><i class="icon-caret-right"></i> Kablo Uzunluğu 2 metre düz</li><li><i class="icon-caret-right"></i> Bağlantı Klavye, RS-232C, HID USB</li><li><i class="icon-caret-right"></i> Okuma Açısı 10 farklı açıda</li><li><i class="icon-caret-right"></i> Programlama Yöntemi Özel Programlama barkodları okutularak</li>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating':5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'14',
      'sKodu': 'KablosuzBarkodOkuyucu',
      'sAciklama': 'Kablosuz Barkod Okuyucu',
      'sSinifKodu' : 'scanner',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 320,
      'lFiyat2' : 320,
      'lFiyat3' : 320,
      'pResim' :require('@/assets/img/shop/14.png'),
      'sDetail' : '<li><i class="icon-caret-right"></i> Teknoloji Lazer</li><li><i class="icon-caret-right"></i> Işık Kaynağı 650 nm Görülebilir Lazer Diyot</li><li><i class="icon-caret-right"></i> Renk Göstergeleri İki renkli LED (mavi - kırmızı)</li><li><i class="icon-caret-right"></i> Ağırlık (Kablosuz) 194</li><li><i class="icon-caret-right"></i> Okuma Derinliği 0~200 mm</li><li><i class="icon-caret-right"></i> Tarama Hızı 200 tarama / s</li><li><i class="icon-caret-right"></i> Bar Genişliği 5 mil @ PSC %90</li><li><i class="icon-caret-right"></i> Okuma Sesi Ayarlanabilir ses ve zaman</li><li><i class="icon-caret-right"></i> Kablosuz</li><li><i class="icon-caret-right"></i> Bağlantı USB, RS232, Klavye, USB-SERIAL</li><li><i class="icon-caret-right"></i> Programlama Yöntemi Özel Programlama barkodları okutularak</li>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'15',
      'sKodu': 'M3Mobile',
      'sAciklama': 'M3 Mobile El Terminali',
      'sSinifKodu' : 'terminal',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 750,
      'lFiyat2' : 750,
      'lFiyat3' : 750,
      'pResim' :require('@/assets/img/shop/15.png'),
      'sDetail' : ' <li><i class="icon-caret-right"></i> CPU 806 MHz</li><li><i class="icon-caret-right"></i> OS Windows mobile 6.5</li><li><i class="icon-caret-right"></i> RAM 256 MB</li><li><i class="icon-caret-right"></i> ROM 1 GB</li><li><i class="icon-caret-right"></i> EKRAN BÜYÜKLÜĞÜ 3.5 inch</li><li><i class="icon-caret-right"></i> EKRAN ÇÖZÜNÜRLÜĞÜ 240 x 320 pixel, colour TFT</li><li><i class="icon-caret-right"></i> BARKOD OKUYUCU Lazer</li><li><i class="icon-caret-right"></i> AĞIRLIK 324 gr</li><li><i class="icon-caret-right"></i> BLUETOOTH Mevcut Class II</li><li><i class="icon-caret-right"></i> WLAN 802.11 a-b-g</li><li><i class="icon-caret-right"></i> GSM/GPRS/EDGE Opsiyonel</li>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'55',
      'sKodu': 'FG1200',
      'sAciklama': 'FG1200 FİYAT GÖR',
      'sSinifKodu' : 'other',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 390,
      'lFiyat2' : 390,
      'lFiyat3' : 390,
      'pResim' :require('@/assets/img/shop/55.png'),
      'sDetail' : '<table class="tablocss" border="0" width="100%" cellspacing="0" cellpadding="0"><tbody><tr><td>&nbsp;<strong>Barkod Okuyucu</strong></td><td>&nbsp;PS 20 Laser</td></tr><tr><td>&nbsp;<strong>G&uuml;&ccedil;</strong></td><td>&nbsp;2200 V/ 50 Hz,2W</td></tr><tr><td>&nbsp;<strong>Boyut</strong></td><td>&nbsp;140x180x120 mm</td></tr><tr><td>&nbsp;<strong>Ağırlık</strong></td><td>&nbsp;1,5 kg</td></tr><tr><td>&nbsp;<strong>Işık Kaynağı</strong></td><td>&nbsp;650 nm g&ouml;r&uuml;lebilir lazer diyot (VLD)</td></tr><tr><td>&nbsp;<strong>Tarama Hızı</strong></td><td>&nbsp;&Ccedil;ok y&ouml;nl&uuml; 1600 tarama/Sn.Tek &ccedil;izgi,74 tarama/Sn</td></tr><tr><td>&nbsp;<strong>Haberleşme</strong></td><td>&nbsp;Ethernet, Opsiyonel Wi-Fi</td></tr></tbody></table>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'16',
      'sKodu': 'ArgoxBarkodYazici',
      'sAciklama': 'Argox Barkod Yazıcı',
      'sSinifKodu' : 'printer',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 220,
      'lFiyat2' : 220,
      'lFiyat3' : 220,
      'pResim' :require('@/assets/img/shop/16.png'),
      'sDetail' : ' <li><i class="icon-caret-right"></i> Özellik Argox OS-214</li><li><i class="icon-caret-right"></i> Baskı Metodu Direkt Termal / Termal Transfer</li><li><i class="icon-caret-right"></i> Baskı hızı 76 mm/sn</li><li><i class="icon-caret-right"></i> Baskı genişliği 104 mm</li><li><i class="icon-caret-right"></i> Baskı uzunluğu 2540 mm</li><li><i class="icon-caret-right"></i> Çözünürlük 203 dpi</li><li><i class="icon-caret-right"></i> Ribon Kapasite 74 metre</li><li><i class="icon-caret-right"></i> Ribon Genişliği 33 mm - 109 mm</li><li><i class="icon-caret-right"></i> Hafıza RAM 512 KB</li><li><i class="icon-caret-right"></i> Flash ROM 512 KB</li><li><i class="icon-caret-right"></i> Arayüz Seri, Paralel</li><li><i class="icon-caret-right"></i> Sensör Sabit</li><li><i class="icon-caret-right"></i> Dil PPLA - PPLB</li>',
      'sStar' : 'Platinum',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    // {
    //   'sFlash' :'',
    //   'nStokID':'19',
    //   'sKodu': 'NCRE-10',
    //   'sAciklama': 'NCR E-10 Yeni Nesil Pos',
    //   'sSinifKodu' : 'pos',
    //   'sDovizCinsi' :'USD',
    //   'nKdvOrani' : 8,
    //   'lEskiFiyat' :'',
    //   'lFiyat1' : 3050,
    //   'lFiyat2' : 3050,
    //   'lFiyat3' : 3050,
    //   'pResim' :require('@/assets/img/shop/19.png'),
    //   'sDetail' : '<li><i class="icon-caret-right"></i> İşlemci: Intel Atom D2550 Processor (1.86 GHZ Dual Core)</li><li><i class="icon-caret-right"></i> İşletim Sistemi: Windows 7, Windows Embedded POSReady 7, Windows Embedded POSReady 2009, SUSE® Linux® Enterprise for Point-of- Service (SLEPOS)</li><li><i class="icon-caret-right"></i> Bellek: 2GB DDR3</li><li><i class="icon-caret-right"></i> Hafıza: 2.5-inch 250GB SATA Hard Disk Drive/ 2.5-inch SATA Solid State Drive</li>',
    //   'sStar' : 'Diamond',
    //   'bPopular' : false,
    //   'bAktif' : true,
    //   'rating': 5,
    //   'free_shipping':true
    // },
    {
      'sFlash' :'',
      'nStokID':'20',
      'sKodu': 'DigiSM-100',
      'sAciklama': 'Digi SM-100 Terazi',
      'sSinifKodu' : 'scale',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 550,
      'lFiyat2' : 550,
      'lFiyat3' : 550,
      'pResim' :require('@/assets/img/shop/20.png'),
      'sDetail' : '<li><i class="icon-caret-right"></i> Boyunlu model, 56 adet ön hafıza tuşlu</li><li><i class="icon-caret-right"></i> Dayanıklı ve kullanışlı yazıcısıyla 80 mm/s etiket, 105 mm/s fiş yazma hızı </li><li><i class="icon-caret-right"></i> 60 mm genişlik ve 220 mm uzunlukta etiket basabilme</li><li><i class="icon-caret-right"></i> Her türlü içerik bilgisini yazar</li><li><i class="icon-caret-right"></i> 6/15 veya 15/30 kg kapasite</li><li><i class="icon-caret-right"></i> Standart eternet opsiyon olarak wireless. RS 232C, paraçekmecesi</li><li><i class="icon-caret-right"></i> Kayan tezgahatar uygulaması </li><li><i class="icon-caret-right"></i> 32x202 okunaklı parlak yeşil ekran</li><li><i class="icon-caret-right"></i> Teraziden ve bilgisayar programından kolay etiket tasarımı </li>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true

    },
    {
      'sFlash' :'',
      'nStokID':'54',
      'sKodu': 'Cas CL3000',
      'sAciklama': 'Cas CL3000 Barkodlu Terazi',
      'sSinifKodu' : 'scale',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 580,
      'lFiyat2' : 580,
      'lFiyat3' : 580,
      'pResim' :require('@/assets/img/shop/54.png'),
      'sDetail' : '<ul><li>15&nbsp;VE&nbsp;30&nbsp;KG SE&Ccedil;ENEKLERİ MEVCUTTUR</li><li>10.000 &uuml;r&uuml;n hafızası</li><li>72 adet &ouml;n hafıza kısayolu</li><li>Etiket uzunluğu 120 mmye kadar</li><li>40 dahili 20 harici etiket formatı</li><li>1 etikette 4 resim basabilir</li><li>1 etikette 2 barkod basabilir</li><li>Baskı hızı 100 mm/s.</li><li>50 km lik baskı</li><li>Barkodu 90&deg;&nbsp;ve 180&deg;e &ccedil;evirir</li><li>T&uuml;m CL serisi terazilerle (CL3000, CL-5200, CL-5200J, CL5000,CL5500D) protokol desteği</li><li>USB, RS-232c, PS / 2, TCP/IP, tarayıcı, yazarkasa</li><li>WiFi ağ kartı ile kablosuz ağ (isteğe bağlı)</li><li>Bir ağdaki maksimum terazi&nbsp;sayısı 99dur</li><li>64/128-bit WEP g&uuml;venlik sistemi</li><li>Veri Bankası Genişletilmiş&nbsp;barkod desteği&nbsp;(en fazla 60 karakter)</li><li>60/150/300 ve 600 kg&nbsp;platform bağlanılarak kapasite y&uuml;kseltilebilir.</li></ul>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true

    },
    {
      'sFlash' :'',
      'nStokID':'56',
      'sKodu': 'Cas ER JR',
      'sAciklama': 'Cas ER JR Barkodsuz Terazi',
      'sSinifKodu' : 'scale',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 210,
      'lFiyat2' : 210,
      'lFiyat3' : 210,
      'pResim' :require('@/assets/img/shop/56.png'),
      'sDetail' : '<p>Dahili Ak&uuml;<br />- Boyunlu ve boyunsuz model se&ccedil;eneği<br />-&nbsp;4 adet direkt PLU erişim tuşu<br />- İkili taksimat ile daha hassas tartım<br />- Buton tuş takımı<br />- G&uuml;nl&uuml;k toplam fonksiyonu<br />- Para &uuml;st&uuml; hesaplama fonksiyonu<br />- Işık siddeti ayarlanabilir g&ouml;sterge aydınlatması&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />- Otomatik kapanma fonsiyonu</p>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true

    },
    {
      'sFlash' :'',
      'nStokID':'57',
      'sKodu': 'Siberguard1kva',
      'sAciklama': 'Siberguard 1kva ups online',
      'sSinifKodu' : 'power',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 219,
      'lFiyat2' : 219,
      'lFiyat3' : 219,
      'pResim' :require('@/assets/img/shop/57.png'),
      'sDetail' : '<p><strong>G&uuml;&ccedil; Aralığı: 1 &ndash; 20 kVA</strong><strong><br />Giriş gerilimi: 1 kVA &ndash; 3 kVA arası (1/1) 110 &ndash; 300 VAC (+, &ndash; 3V)<br />6 kVA &ndash; 10 kVA arası (1/1) 176 &ndash; 279 VAC (+, &ndash; 3V) 10<br />kVA &ndash; 20 kVA arası (3/1) 304 &ndash; 478 VAC (+, &ndash; 3V)<br />&Ccedil;ıkış gerilimi: 1 kVA &ndash; 20 kVA arası 220/230/240 VAC (Ayarlanabilir)</strong></p>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true

    },

    {
      'sFlash' :'',
      'nStokID':'58',
      'sKodu': 'Siberguard10kva',
      'sAciklama': 'Siberguard 10kva ups online',
      'sSinifKodu' : 'power',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 1450,
      'lFiyat2' : 1450,
      'lFiyat3' : 1450,
      'pResim' :require('@/assets/img/shop/57.png'),
      'sDetail' : '<p><strong>G&uuml;&ccedil; Aralığı: 1 &ndash; 20 kVA</strong><strong><br />Giriş gerilimi: 1 kVA &ndash; 3 kVA arası (1/1) 110 &ndash; 300 VAC (+, &ndash; 3V)<br />6 kVA &ndash; 10 kVA arası (1/1) 176 &ndash; 279 VAC (+, &ndash; 3V) 10<br />kVA &ndash; 20 kVA arası (3/1) 304 &ndash; 478 VAC (+, &ndash; 3V)<br />&Ccedil;ıkış gerilimi: 1 kVA &ndash; 20 kVA arası 220/230/240 VAC (Ayarlanabilir)</strong></p>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true

    },
    {
      'sFlash' :'',
      'nStokID':'60',
      'sKodu': 'rafetiketi',
      'sAciklama': 'Raf Etiketi 38x100 TERMAL ETİKET',
      'sSinifKodu' : 'label',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 2,
      'lFiyat2' : 2,
      'lFiyat3' : 2,
      'pResim' :require('@/assets/img/shop/60.png'),
      'sDetail' : 'Dikey Raf Etiketi 38x100 TERMAL ETİKET',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true

    },
    {
      'sFlash' :'',
      'nStokID':'61',
      'sKodu': 'terazirulosu',
      'sAciklama': 'Terazi rulosu 40x58 TERMAL',
      'sSinifKodu' : 'label',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 1.60,
      'lFiyat2' : 1.60,
      'lFiyat3' : 1.60,
      'pResim' :require('@/assets/img/shop/61.png'),
      'sDetail' : 'Dikey Raf Etiketi 38x100 TERMAL ETİKET 500lü sarım',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true

    },
    {
      'sFlash' :'',
      'nStokID':'62',
      'sKodu': 'kasarulosu',
      'sAciklama': 'Kasa rulosu 80x40 Termal',
      'sSinifKodu' : 'label',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 1.50,
      'lFiyat2' : 1.50,
      'lFiyat3' : 1.50,
      'pResim' :require('@/assets/img/shop/62.png'),
      'sDetail' : 'Kasa Rulosu 80x40 Termal',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true

    },
    {
      'sFlash' :'',
      'nStokID':'63',
      'sKodu': 'urunetiketi',
      'sAciklama': 'Ürün Etiketi 20x40 4lu sıra 6000',
      'sSinifKodu' : 'label',
      'sDovizCinsi' :'USD',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 9.99,
      'lFiyat2' : 9.99,
      'lFiyat3' : 9.99,
      'pResim' :require('@/assets/img/shop/63.png'),
      'sDetail' : 'Ürün Etiketi 20x40 4lu sıra 6000',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true

    },
    {
      'sFlash' :'',
      'nStokID':'25',
      'sKodu': 'E-Fatura',
      'sAciklama': 'Karpin i-Dönüşüm',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 19990,
      'lFiyat2' : 19990,
      'lFiyat3' : 19990,
      'pResim' :require('@/assets/img/shop/25.png'),
      'sDetail' : 'Kestiğiniz fatura E-Fatura mükellefine ait ise E-Fatura olarak değilse E-Arşiv faturası olarak tek tuşla entegrasyonunu sağlıyor ve karşı tarafın vergi kimlik numarasına gönderiyoruz, Sizin vergi kimlik numaranıza gelen faturalarda stok eşleştirmesi imkanı sağlayarak eşleşmiş stoklara faturanın otomatik işlenmesini ve stoklara girişini sağlıyoruz. Muhasebe Yevmiye kayıtlarınızı e-defter olarak kolayca aktarmanızı sağlıyor ve takibini kolaylaştırıyoruz.',
      'sStar' : 'Platinum',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'26',
      'sKodu': 'KarpinMobile',
      'sAciklama': 'Karpin Mobile',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 22990,
      'lFiyat2' : 22990,
      'lFiyat3' : 22990,
      'pResim' :require('@/assets/img/shop/26.png'),
      'sDetail' : ' <h6> Karpin <span>Mobile</span> </h6><p>Akıllı Telefon ve Tablet üzerinden çalışma</p><p>Bilgisayar Ortamında yapabileceğiniz Tüm İşlemler artık Akıllı Telefon ve Tabletlerde </p><p>Alıştan Satışa İade Etmeye, Sayımdan Sipariş ve Mal Kabule ,Stok Tanıtımında Cari ve Müşteri Tanımlama ve İzlemeye. Fiyat Gör işlemlerinden Envanter,Barkod ve Fiyat Sorgulamaya ve değiştirmeye. Hızlı Stok Kartı Tanıtımından Hızlı Etiket Yazdırma Seçeneklerine, Reyon Fişi Düzenleyerek Satış İşlemlerinden İade Listesi Hazırlamaya. Tahsilat İşlemlerinden Ödeme Yapmaya Sipariş verme işlemlerinden Siparişin kabulu ve Sevkiyat işlemlerine kadar. Şubelerden gelen Sevkiyatların Kabülünden ,Yapılacak ve Yapılan Teslimatların Kontrolüne ve Şubeye gelen stokların kontrolüne kadar Pratikte Yapılan tüm işlemler artık Akıllı Telefon ve Tabletlerde </p>',
      'sStar' : 'Platinum',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'27',
      'sKodu': 'PosScreen',
      'sAciklama': 'Satış Noktası Yazılımı',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 16995,
      'lFiyat2' : 16995,
      'lFiyat3' : 16995,
      'pResim' :require('@/assets/img/shop/27.png'),
      'sDetail' : '<h6> <span>Yeni Nesil Yazarkasa Pos Çözümü</span> </h6><p>Hızlı ve kullanımı kolay, dokunmatik ekran destekli satış ekranı yardımıyla zamandan tasarruf sağlayan Karpin Perakende ile kasiyerin tek tuşla satış, iade, kampanya, servis ve raporlama gibi her bir uygulamayı aynı ekrandan yönetebilmesi sağlanır. Arka ofis uygulamalarıyla ise taksitli satış ve vade farkı, mağaza performans raporlamaları, analiz, mal kabul ve onaylama, banka ve kasa işlemleri pratik bir şekilde gerçekleştirilebilir.</p><p>Dokunmatik Ekran Üzerinden, Peşin ve Açık Hesaba Satış Yapma, Satış Bekletme, Kolay Menü,Sanal Klavye, Fiş Yazdırma, Fatura Yazdırma ve Yazarkasadan fiş kesme.Teraziden Bilgi alma ve Tartılı ürün satışı.Menüden Satış, Tutara görme Miktar hesaplama,İskonto yapma , ikram verme. Puan ve Promosyon.Değişik Ödeme Türlerine göre Tahsilat yapma ve Veresiye yapma. Paraüstü Takibi ve Parçalı Tahsilat,Satıcı Takibi , Masa Takibi Veresiyeden tahsilat ve daha nice işlem ve raporlar </p><h6>Raporlama</h6><p>Barkod Yazılımevi bambaşka bir raporlama aracı sunuyor. İnteraktif raporlama imkanı veren bu araç sayesinde raporlarınızı tasarlayın, kaydedin, tasarım kriterlerinizi tekrar tekrar kullanın. Ayrıca raporlarınızı tabloya alın, gruplayın ve ara toplamlar alın. Kısacası raporlama aracı ile raporlar üzerinde tam kontrol sağlayın. </p>',
      'sStar' : 'Platinum',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'28',
      'sKodu': 'Turab',
      'sAciklama': 'Mobil Terminal Yazılımı',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 16995,
      'lFiyat2' : 16995,
      'lFiyat3' : 16995,
      'pResim' :require('@/assets/img/shop/28.png'),
      'sDetail' : '<h6> Karpin <span>El Terminali</span> Çözümü</h6><p>Bilgisayar Ortamında yapabileceğiniz Tüm İşlemler artık El Terminali Cihazlarda </p><p>Alıştan Satışa İade Etmeye, Sayımdan Sipariş ve Mal Kabule ,Stok Tanıtımında Cari ve Müşteri Tanımlama ve İzlemeye. Fiyat Gör işlemlerinden Envanter,Barkod ve Fiyat Sorgulamaya ve değiştirmeye. Hızlı Stok Kartı Tanıtımından Hızlı Etiket Yazdırma Seçeneklerine, Reyon Fişi Düzenleyerek Satış İşlemlerinden İade Listesi Hazırlamaya. Tahsilat İşlemlerinden Ödeme Yapmaya Sipariş verme işlemlerinden Siparişin kabulu ve Sevkiyat işlemlerine kadar. Şubelerden gelen Sevkiyatların Kabülünden ,Yapılacak ve Yapılan Teslimatların Kontrolüne ve Şubeye gelen stokların kontrolüne kadar Pratikte Yapılan tüm işlemler artık Mobil Akıllı Cihazlarda </p>',
      'sStar' : 'Platinum',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'30',
      'sKodu': 'KarpinEntegre',
      'sAciklama': 'Karpin Entegre E-Ticaret Sitenizle Entegre',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 19950,
      'lFiyat2' : 19950,
      'lFiyat3' : 19950,
      'pResim' :require('@/assets/img/shop/30.png'),
      'sDetail' : 'Sisteminizi E-Ticaret Sayfanızla Entegre ediyoruz, Satış yapıldığında Stoklarınızdan düşmesini sağlıyor faturasını otomatik hazırlıyor Sitede envanter bilgisinin güncel olmasını ve yok a satılmasını engelliyoruz, Programdan fiyat değiştiğinde sitenizdede değiştiriyor pasife aldığınızda sitede de pasife alıyoruz',
      'sStar' : 'Platinum',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'31',
      'sKodu': 'KarpinVale',
      'sAciklama': 'Karpin Vale Yazılımı',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 29900,
      'lFiyat2' : 29900,
      'lFiyat3' : 29900,
      'pResim' :require('@/assets/img/shop/31.png'),
      'sDetail' : 'Vale Araç kontrol sisteminizi kuruyoruz, Giriş Çıkışlarınız ve Teslimatlarınız ile hesaplarınız kontrol altında',
      'sStar' : 'Platinum',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'33',
      'sKodu': 'KarpinPos',
      'sAciklama': 'Karpin Restaurant-Cafe-Bar-Tekel',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 16995,
      'lFiyat2' : 16995,
      'lFiyat3' : 16995,
      'pResim' :require('@/assets/img/shop/33.png'),
      'sDetail' : ' <h6 class="titles-span">Karpin <span>POS</span> Çözümü</h6><p>Satış Yönetimi Yazılımı Temel Özellikleri</p><ul class="list"><li><i class="fa fa-check"></i> Stok Tanımlama</li><li><i class="fa fa-check"></i> Etiket Yazdırma ve Fiyat Sorgulama</li><li><i class="fa fa-check"></i> Peşin Satış</li><li><i class="fa fa-check"></i> Veresiye Satış</li><li><i class="fa fa-check"></i> Veresiye Tahsilat</li><li><i class="fa fa-check"></i> İade/Değişim</li><li><i class="fa fa-check"></i> Alış Faturası</li><li><i class="fa fa-check"></i> Satış Faturası</li><li><i class="fa fa-check"></i> İade Faturası</li><li><i class="fa fa-check"></i> Promosyon</li><li><i class="fa fa-check"></i> CallerID (Çağrı Kaydı) Cihazı ile Satış</li><li><i class="fa fa-check"></i> Raporlama</li><li><i class="fa fa-check"></i> Fiş Yazıcısı</li><li><i class="fa fa-check"></i> Tartım Terazisi ile Çalışma</li><li><i class="fa fa-check"></i> Para Çekmecesi ile Çalışma</li><li><i class="fa fa-check"></i> Müşteri Göstergesi Kullanma</li><li><i class="fa fa-check"></i> Yazarkasadan Satış Fişini Alma</li><li><i class="fa fa-check"></i> Yetkilendirme</li><li><i class="fa fa-check"></i> Offline Bağımsız çalışma ile Bağımsız kasalar ve Şubeler</li><li><i class="fa fa-check"></i> Yeni Nesil Yazarkasadan Satış Fişinizi Anlık Alın</li></ul>',
      'sStar' : 'Diamond',
      'bPopular' : true,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'34',
      'sKodu': 'KarpinSaha',
      'sAciklama': 'Karpin Sahada Satış Sistemi',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 39950,
      'lFiyat2' : 39950,
      'lFiyat3' : 39950,
      'pResim' :require('@/assets/img/shop/34.png'),
      'sDetail' : ' <h6 class="titles-span">Karpin <span>Saha Satış</span> Çözümü</h6><p>Satış Yönetimi Yazılımı Temel Özellikleri</p><ul class="list"><li><i class="fa fa-check"></i> Rut Takibi</li><li><i class="fa fa-check"></i> Stok Tanımlama</li><li><i class="fa fa-check"></i> Cari Hesaplar</li><li><i class="fa fa-check"></i> Etiket Yazdırma ve Fiyat Sorgulama</li><li><i class="fa fa-check"></i> Fiyat Değiştirme</li><li><i class="fa fa-check"></i> Peşin Satış</li><li><i class="fa fa-check"></i> Veresiye Satış</li><li><i class="fa fa-check"></i> Veresiye Tahsilat</li><li><i class="fa fa-check"></i> İade/Değişim</li><li><i class="fa fa-check"></i> Alış Faturası</li><li><i class="fa fa-check"></i> İade Faturası</li><li><i class="fa fa-check"></i> Mal Kabul</li><li><i class="fa fa-check"></i> Sipariş</li><li><i class="fa fa-check"></i> Araç Yükleme Boşaltma</li><li><i class="fa fa-check"></i> Promosyon</li><li><i class="fa fa-check"></i> Paket Sevkiyat</li><li><i class="fa fa-check"></i> Sayım</li><li><i class="fa fa-check"></i> Ziyaret</li><li><i class="fa fa-check"></i> KM Takibi</li><li><i class="fa fa-check"></i> Evraklarda GPS Konum Kaydetme</li><li><i class="fa fa-check"></i> Periyodik GPS Konum Bildirme</li><li><i class="fa fa-check"></i> Zimmet</li><li><i class="fa fa-check"></i> Raporlama</li><li><i class="fa fa-check"></i> Fiş Yazıcısı</li><li><i class="fa fa-check"></i> Barkod Yazdırma</li><li><i class="fa fa-check"></i> Yetkilendirme</li></ul>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'35',
      'sKodu': 'KarpinKobi',
      'sAciklama': 'Karpin Kobi Yazılımı',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 29950,
      'lFiyat2' : 29950,
      'lFiyat3' : 29950,
      'pResim' :require('@/assets/img/shop/35.png'),
      'sDetail' : ' <h6> Karpin <span>Kobi </span> Güçlendirir</h6><p>İşletmelerin ihtiyaç duydukları tüm iş süreçlerini entegre bir şekilde sağlayan ticari yazılım KARPİN, Üretimden Sevkiyata, Toptan ve Parekende satış kanallarında gerçekleşen satıştan satış sonrası hizmetlere kadar; bir perakendeci, toptancı ya da üretici firmanın gereksinim duyacağı tüm iş süreçlerini baştan sona kapsamaktadır. KARPİN, tüm iş süreçlerinin uçtan uca entegre bir yapıda yürütülmeleri sayesinde hataların önüne geçer, izlenebilirliği ve güvenle karar almayı sağlar, departmanlar arası etkileşimi sağlayarak kurumsal veri bütünlüğünü güçlendirir ve böylelikle firmaların kurumsal gelişim süreçlerini hızlandırır. </p><h6>Finans</h6><p>Finans, alıcı ve satıcı cari hesaplarının, bankanın, kredi kartlarının, çek ve senetlerin takibini ve kasa işlemlerini kapsar, nakit akışınızı yönetir. Ödeme ve tahsilat planı tanımları ise her tür ihtiyacınıza cevap verecek şekilde esnektir. Belirlenen limit ve kurallar çerçevesinde risk takibinizin yapılmasını sağlar. Bankalardaki ticari ve kredi hesaplarınızı, hesap türü seçerek kaydedebilir, bu hesaplara ait hareketleri yerel para birimi yanında dövizli olarak da izleyebilirsiniz. Kredi kartları ile ilgili banka hesaplarını tanımlayabilir, ilgili komisyonları girerek geri ödeme planları oluşturabilirsiniz. Kredi kartları ile yaptığınız satışlarla ilgili bankadan gelecek ödemeleri izleyebilirsiniz. Karpin in banka kredi takip özelliği, bankalardan aldığınız ticari kredileri etkin biçimde izlemenizi sağlar. Bu özellik ile hem teminat karşılığında, hem de teminatsız olarak aldığınız nakdi kredilerin takibini yapabilirsiniz. Kredi geri ödemesi, bakiye ve kalan borç durumunuzu her an güncel olarak görebilir, kredilerinizin geri ödemelerini planlayarak nakit akışınızı takip edebilirsiniz. </p><h6>Stok</h6><p>ERP Çözümleri ile anlık stoklarınızı, stok değer ve seviyelerinizi izleyerek yönetebilir,envanter maliyetlerinizi kontrol edebilirsiniz.Ürünlerinizin fotoğraflarını malzeme kartına ekleyebilir, ürün ile istediğiniz birimleri eşleştirebilir, her birime sınırsız sayıda barkod atayabilirsiniz. Maliyetlendirme işlemlerinizi ortalama, ağırlıklı ortalama, LIFO, FIFO ya da dönemsel ortalama değerleme yöntemlerinden istediğinizi kullanarak yapabilirsiniz. Ürünleri seri ve lot numaraları ile izleyebilirsiniz. Ürünler Renk,Beden ve Kavala Bilgilerini tanımlayabilirsiniz.Malzemelere uygulanan ÖTV ve telekomünikasyon hizmetlerinde geçerli olan özel iletişim vergisi için geçerli olacak ek vergileri özellikleri ile tanımlayarak fiş ve faturalarınızda uygulayabilirsiniz. </p><h6>Raporlama</h6><p>Barkod Yazılımevi bambaşka bir raporlama aracı sunuyor. İnteraktif raporlama imkanı veren bu araç sayesinde raporlarınızı tasarlayın, kaydedin, tasarım kriterlerinizi tekrar tekrar kullanın. Ayrıca raporlarınızı tabloya alın, gruplayın ve ara toplamlar alın. Kısacası raporlama aracı ile raporlar üzerinde tam kontrol sağlayın. </p>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'36',
      'sKodu': 'KarpinTicari',
      'sAciklama': 'Karpin Ticari Yazılımı',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 34950,
      'lFiyat2' : 34950,
      'lFiyat3' : 34950,
      'pResim' :require('@/assets/img/shop/36.png'),
      'sDetail' : '<h6> Karpin <span>Ticari </span> Çözüm</h6><p>İşletmelerin ihtiyaç duydukları tüm iş süreçlerini entegre bir şekilde sağlayan ticari yazılım KARPİN, Üretimden Sevkiyata, Toptan ve Parekende satış kanallarında gerçekleşen satıştan satış sonrası hizmetlere kadar; bir perakendeci, toptancı ya da üretici firmanın gereksinim duyacağı tüm iş süreçlerini baştan sona kapsamaktadır. KARPİN, tüm iş süreçlerinin uçtan uca entegre bir yapıda yürütülmeleri sayesinde hataların önüne geçer, izlenebilirliği ve güvenle karar almayı sağlar, departmanlar arası etkileşimi sağlayarak kurumsal veri bütünlüğünü güçlendirir ve böylelikle firmaların kurumsal gelişim süreçlerini hızlandırır. </p><h6>Finans</h6><p>Finans, alıcı ve satıcı cari hesaplarının, bankanın, kredi kartlarının, çek ve senetlerin takibini ve kasa işlemlerini kapsar, nakit akışınızı yönetir. Ödeme ve tahsilat planı tanımları ise her tür ihtiyacınıza cevap verecek şekilde esnektir. Belirlenen limit ve kurallar çerçevesinde risk takibinizin yapılmasını sağlar. Bankalardaki ticari ve kredi hesaplarınızı, hesap türü seçerek kaydedebilir, bu hesaplara ait hareketleri yerel para birimi yanında dövizli olarak da izleyebilirsiniz. Kredi kartları ile ilgili banka hesaplarını tanımlayabilir, ilgili komisyonları girerek geri ödeme planları oluşturabilirsiniz. Kredi kartları ile yaptığınız satışlarla ilgili bankadan gelecek ödemeleri izleyebilirsiniz. Karpin in banka kredi takip özelliği, bankalardan aldığınız ticari kredileri etkin biçimde izlemenizi sağlar. Bu özellik ile hem teminat karşılığında, hem de teminatsız olarak aldığınız nakdi kredilerin takibini yapabilirsiniz. Kredi geri ödemesi, bakiye ve kalan borç durumunuzu her an güncel olarak görebilir, kredilerinizin geri ödemelerini planlayarak nakit akışınızı takip edebilirsiniz. </p><h6>Stok</h6><p>ERP Çözümleri ile anlık stoklarınızı, stok değer ve seviyelerinizi izleyerek yönetebilir,envanter maliyetlerinizi kontrol edebilirsiniz.Ürünlerinizin fotoğraflarını malzeme kartına ekleyebilir, ürün ile istediğiniz birimleri eşleştirebilir, her birime sınırsız sayıda barkod atayabilirsiniz. Maliyetlendirme işlemlerinizi ortalama, ağırlıklı ortalama, LIFO, FIFO ya da dönemsel ortalama değerleme yöntemlerinden istediğinizi kullanarak yapabilirsiniz. Ürünleri seri ve lot numaraları ile izleyebilirsiniz. Ürünler Renk,Beden ve Kavala Bilgilerini tanımlayabilirsiniz.Malzemelere uygulanan ÖTV ve telekomünikasyon hizmetlerinde geçerli olan özel iletişim vergisi için geçerli olacak ek vergileri özellikleri ile tanımlayarak fiş ve faturalarınızda uygulayabilirsiniz. </p><h6>El Terminali Uygulamaları</h6><p>• Sayımlar ofis depoları ve müşteri depolarında mobil el terminali üzerinde adet veya lot bazında girilerek sayım fişleri oluşturulur.Girilen sayıma ait sonuç mobil el terminalinde anında listelenerek azami kontrol sağlanır. </p><p>• Mobil mal kabul uygulamaları süreç akış kuralına bağlı olarak çalışır. Toptan alış veya konsinye alışlar mobil el terminalleri ile verilen sipariş kontrolü yapılarak veya verilen sipariş entegrasyonuna bakılmadan girilebilir. </p><p>• Mal kabul ve sevkiyat işlemleri adet veya lot barkodu okutarak gerçekleştirilebilir. Böylece sevkiyatlarda hız ve pratiklik sağlanır. </p><p>• Merkezden mağazalara yapılan sevkiyatlar mağazada mobil el terminalleri ile onaylanır. Aynı şekilde mağazalar arası transferler ve mağazalardan merkeze iadeler de mobil el terminalleri ile onaylanarak ürünün hareketleri anlık olarak izlenebilir. </p><p>• Sevkiyat süreç akış kuralına bağlı olarak, mobil el terminali üzerinde ürün toplama ve paketleme, oluşan paketlerin sevkiyatı, irsaliye ve faturalama işlemleri gerçekleştirilir. </p><h6>Raporlama</h6><p>Barkod Yazılımevi bambaşka bir raporlama aracı sunuyor. İnteraktif raporlama imkanı veren bu araç sayesinde raporlarınızı tasarlayın, kaydedin, tasarım kriterlerinizi tekrar tekrar kullanın. Ayrıca raporlarınızı tabloya alın, gruplayın ve ara toplamlar alın. Kısacası raporlama aracı ile raporlar üzerinde tam kontrol sağlayın. </p>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    
    {
      'sFlash' :'',
      'nStokID':'37',
      'sKodu': 'KarpinErp',
      'sAciklama': 'Karpin Erp İş Yönetimi',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 92950,
      'lFiyat2' : 92950,
      'lFiyat3' : 92950,
      'pResim' :require('@/assets/img/shop/37.png'),
      'sDetail' : '<h6> Karpin <span>ERP </span> Çözümü</h6><p>İşletmelerin ihtiyaç duydukları tüm iş süreçlerini entegre bir şekilde sağlayan ticari yazılım KARPİN, Üretimden Sevkiyata, Toptan ve Parekende satış kanallarında gerçekleşen satıştan satış sonrası hizmetlere kadar; bir perakendeci, toptancı ya da üretici firmanın gereksinim duyacağı tüm iş süreçlerini baştan sona kapsamaktadır. KARPİN, tüm iş süreçlerinin uçtan uca entegre bir yapıda yürütülmeleri sayesinde hataların önüne geçer, izlenebilirliği ve güvenle karar almayı sağlar, departmanlar arası etkileşimi sağlayarak kurumsal veri bütünlüğünü güçlendirir ve böylelikle firmaların kurumsal gelişim süreçlerini hızlandırır. </p><h6>Finans</h6><p>Finans, alıcı ve satıcı cari hesaplarının, bankanın, kredi kartlarının, çek ve senetlerin takibini ve kasa işlemlerini kapsar, nakit akışınızı yönetir. Ödeme ve tahsilat planı tanımları ise her tür ihtiyacınıza cevap verecek şekilde esnektir. Belirlenen limit ve kurallar çerçevesinde risk takibinizin yapılmasını sağlar. Bankalardaki ticari ve kredi hesaplarınızı, hesap türü seçerek kaydedebilir, bu hesaplara ait hareketleri yerel para birimi yanında dövizli olarak da izleyebilirsiniz. Kredi kartları ile ilgili banka hesaplarını tanımlayabilir, ilgili komisyonları girerek geri ödeme planları oluşturabilirsiniz. Kredi kartları ile yaptığınız satışlarla ilgili bankadan gelecek ödemeleri izleyebilirsiniz. Karpin in banka kredi takip özelliği, bankalardan aldığınız ticari kredileri etkin biçimde izlemenizi sağlar. Bu özellik ile hem teminat karşılığında, hem de teminatsız olarak aldığınız nakdi kredilerin takibini yapabilirsiniz. Kredi geri ödemesi, bakiye ve kalan borç durumunuzu her an güncel olarak görebilir, kredilerinizin geri ödemelerini planlayarak nakit akışınızı takip edebilirsiniz. </p><h6>Satış ve Satınalma</h6><p>Satınalma ve Satış Karpin ile bir siparişi sisteme girdiğinizde, sipariş ve teslimat için gerekli evrakların oluşturulmasından,malın faturalandırılmasına ve zamanında teslimat yapılmasına kadar tüm satış ve sevkiyat sürecini kontrol edebilirsiniz.Aldığınız sipariş miktarı elinizde bulunan miktardan fazla ise, otomatik karşı sipariş oluşturabilirsiniz.Satış koşullarınızı gerek sipariş, irsaliye ve fatura geneli için, gerekse bu belgelerde yer alan her malzeme için ayrı ayrı uygulayabilirsiniz.Ürün ve müşteri bazında istediğiniz sayıda ve istediğiniz para birimi üzerinden satış fiyatı tanımlayabilir, bu fiyatın hangi koşullarda geçerli olacağını parametrelerle belirleyebilirsiniz. Ayrıca Mağaza bazında fiyat tanımlayabilirsiniz. Satış fiyatlarını her malzeme/hizmet için tek tek ya da liste halinde oluşturabilir ve hangi tarihler arasında geçerli olacağını belirleyebilirsiniz. Satış fiyatlarınızı toplu olarak güncelleyebilirsiniz. Satıcı bazında satış hedeflerini belirleyebilir, satış performans ölçümünü sağlayabilirsiniz.Market Çözümleri ile Satınalma işlemlerinizi, sipariş aşamasından, malın teslim alınmasına ve fatura girişine kadar tüm aşamaları ile kontrol edebilirsiniz. Güncel ödemeleriniz gibi bilgilere hızlı şekilde erişebilir, aldığınız fiyat, indirim ve ödeme koşulları ile bu fiyat ve indirimlerin geçerlilik süreleri ile ilgili maliyetlerini de takip edebilirsiniz. </p><h6>Stok</h6><p>ERP Çözümleri ile anlık stoklarınızı, stok değer ve seviyelerinizi izleyerek yönetebilir,envanter maliyetlerinizi kontrol edebilirsiniz.Ürünlerinizin fotoğraflarını malzeme kartına ekleyebilir, ürün ile istediğiniz birimleri eşleştirebilir, her birime sınırsız sayıda barkod atayabilirsiniz. Maliyetlendirme işlemlerinizi ortalama, ağırlıklı ortalama, LIFO, FIFO ya da dönemsel ortalama değerleme yöntemlerinden istediğinizi kullanarak yapabilirsiniz. Ürünleri seri ve lot numaraları ile izleyebilirsiniz. Ürünler Renk,Beden ve Kavala Bilgilerini tanımlayabilirsiniz.Malzemelere uygulanan ÖTV ve telekomünikasyon hizmetlerinde geçerli olan özel iletişim vergisi için geçerli olacak ek vergileri özellikleri ile tanımlayarak fiş ve faturalarınızda uygulayabilirsiniz. </p><h6>Muhasebe</h6><p>Erp Çözümlerimiz size mevzuat gereklerine tam uyumlu çalışma olanağı sağlar. Standart hesap planı otomatik olarak oluşur.Hiyerarşik yapıya sahip hesap planı ile ana hesap altında yer alacak alt hesapları esnek bir yapıda istediğiniz şekilde tanımlayabilirsiniz. Muhasebeleştirme ile de diğer program bölümlerinde yaptığınız işlemler için muhasebede oluşması gereken fişlerin otomatik olarak oluşturulmasını sağlayabilirsiniz.Mali tablolarınızı tanımlayabilir ve yasal olarak alınması zorunlu tabloları yasaların öngördüğü ayrıntıda ve düzeyde alabilirsiniz. e-Beyanname özelliği ile vergilendirme döneminde mal ve hizmet alımları ile mal ve hizmet satışlarının bildirilmesinde kullanılan Form Ba ve Form Bs isimli bildirim formlarını elektronik ortamda verebilirsiniz. </p><h6>Perakende</h6><p>Hızlı ve kullanımı kolay, dokunmatik ekran destekli satış ekranı yardımıyla zamandan tasarruf sağlayan Business Perakende ile kasiyerin tek tuşla satış, iade, kampanya, servis ve raporlama gibi her bir uygulamayı aynı ekrandan yönetebilmesi sağlanır. Arka ofis uygulamalarıyla ise taksitli satış ve vade farkı, mağaza performans raporlamaları, analiz, mal kabul ve onaylama, banka ve kasa işlemleri pratik bir şekilde gerçekleştirilebilir. </p><h6>İnsan Kaynakları</h6><p>Entegre çalışabilen İNSAN KAYNAKLARI Sosyal Güvenlik Kurumu’na bağlı çalışanların (4-a) tüm mevzuat ihtiyaçlarını tam olarak karşılar. Tüm işletmelerin ve mevsimlik işçi çalıştıran firmaların sicil ve ücret yönetimi konusundaki gereksinimlerine esnek ve kolay kullanımı ile cevap verir. Bordro işlemlerinin, yasal prosedürlerin ve raporların otomasyonu mevzuat bilgisi gerekliliğini minimize ederek iş gücü tasarrufu sağlar. </p><h6>Market</h6><p>Entegre çalışabilen Market Modülü, Piyasada mevcut Tüm Yazarkasa,Pos ve terazilere bilgi gönderebilme Yazarkasa ve Pos Kasalardan Satış Çekme imkanı sağlar. Tek Ekrandan Yeni Stok tanımlama ve Stok Listelerinden Toplu Fiyat değiştirme imkanı ve Değişen ve Yeni oluşan Kart bilgilerini kontrol edebilme imkanı sağlar. Seçimli olarak veya Yeni Açılan kartlar ile Fiyatı Değişen Kartlardan Barkod Yazıcılara Etiket Yazdırma kolaylığı vardır. Hızlı Etiket yazdırma fonksiyonu ile barkod bilgisi okutulan veya seçilen ürüne direkt tanımlı olan yazıcıdan yazıcı çıktısı alarak iş gücü ve zaman tasarrufu sağlar. </p><h6>El Terminali Uygulamaları</h6><p>• Sayımlar ofis depoları ve müşteri depolarında mobil el terminali üzerinde adet veya lot bazında girilerek sayım fişleri oluşturulur.Girilen sayıma ait sonuç mobil el terminalinde anında listelenerek azami kontrol sağlanır. </p><p>• Mobil mal kabul uygulamaları süreç akış kuralına bağlı olarak çalışır. Toptan alış veya konsinye alışlar mobil el terminalleri ile verilen sipariş kontrolü yapılarak veya verilen sipariş entegrasyonuna bakılmadan girilebilir. </p><p>• Mal kabul ve sevkiyat işlemleri adet veya lot barkodu okutarak gerçekleştirilebilir. Böylece sevkiyatlarda hız ve pratiklik sağlanır. </p><p>• Merkezden mağazalara yapılan sevkiyatlar mağazada mobil el terminalleri ile onaylanır. Aynı şekilde mağazalar arası transferler ve mağazalardan merkeze iadeler de mobil el terminalleri ile onaylanarak ürünün hareketleri anlık olarak izlenebilir. </p><p>• Sevkiyat süreç akış kuralına bağlı olarak, mobil el terminali üzerinde ürün toplama ve paketleme, oluşan paketlerin sevkiyatı, irsaliye ve faturalama işlemleri gerçekleştirilir. </p><p>• Mobil cihaz üzerinden ürün sorgulama yapılabilir. </p><h6>Raporlama</h6><p>Barkod Yazılımevi bambaşka bir raporlama aracı sunuyor. İnteraktif raporlama imkanı veren bu araç sayesinde raporlarınızı tasarlayın, kaydedin, tasarım kriterlerinizi tekrar tekrar kullanın. Ayrıca raporlarınızı tabloya alın, gruplayın ve ara toplamlar alın. Kısacası raporlama aracı ile raporlar üzerinde tam kontrol sağlayın. </p><h6>Yönetici Konsolu</h6><p>Yönetici Konsolu, firmanız ile ilgili genel durumu ekranınıza getiriyor.Kasanızda ne kadar paranız var? Ne kadar ödeme yapacaksınız? En çok sattığınız ürünler neler? En çok kime satış yaptınız? Şirket Karlılığınız nedir ? Gelir Tablosu nasıl gerçekleşti? Artık Yönetici Konsolu sayesinde, rapor almadan da tüm bu bilgileri görebilirsiniz. </p>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'38',
      'sKodu': 'KarpinPerakende',
      'sAciklama': 'Karpin Perakende Mağaza',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 24950,
      'lFiyat2' : 24950,
      'lFiyat3' : 24950,
      'pResim' :require('@/assets/img/shop/38.png'),
      'sDetail' : '<h6> <span>Perakende Çözümü</span> </h6><p>Hızlı ve kullanımı kolay, dokunmatik ekran destekli satış ekranı yardımıyla zamandan tasarruf sağlayan Business Perakende ile kasiyerin tek tuşla satış, iade, kampanya, servis ve raporlama gibi her bir uygulamayı aynı ekrandan yönetebilmesi sağlanır. Arka ofis uygulamalarıyla ise taksitli satış ve vade farkı, mağaza performans raporlamaları, analiz, mal kabul ve onaylama, banka ve kasa işlemleri pratik bir şekilde gerçekleştirilebilir. </p><p>Perakendecilik Uygulamaları.Detaylı Yetkilendirme ve Kontrol ile Taksitli Satış,Peşin Satış,Sipariş Sevkiyat,Mal Kabul,Stok ve Depo Takibi, Sonradan Teslim ve Bekleyen Durumu. Teslimat Takibi,Avukatlık ve İcralıklar,Müşteri Takipleri ile Geciktiren ve İlk Ödemesini geciktiren Müşterilerin Kontrolü, Mektup ve SMS Gönderme ,Alacak Analizleri,Beğeni ve Kontroller,Tedarikçi Teminci ve İade Yönetiminden Rakip firma kontrolü ile Anlaşma ve Sözleşme Sonuçlarının takibine,Dönem Sonu işlemleri faaliyet raporları ile Karlılık Analizleri </p><h6>El Terminali Uygulamaları</h6><p>• Sayımlar ofis depoları ve müşteri depolarında mobil el terminali üzerinde adet veya lot bazında girilerek sayım fişleri oluşturulur.Girilen sayıma ait sonuç mobil el terminalinde anında listelenerek azami kontrol sağlanır. </p><p>• Mobil mal kabul uygulamaları süreç akış kuralına bağlı olarak çalışır. Toptan alış veya konsinye alışlar mobil el terminalleri ile verilen sipariş kontrolü yapılarak veya verilen sipariş entegrasyonuna bakılmadan girilebilir. </p><p>• Mal kabul ve sevkiyat işlemleri adet veya lot barkodu okutarak gerçekleştirilebilir. Böylece sevkiyatlarda hız ve pratiklik sağlanır. </p><p>• Merkezden mağazalara yapılan sevkiyatlar mağazada mobil el terminalleri ile onaylanır. Aynı şekilde mağazalar arası transferler ve mağazalardan merkeze iadeler de mobil el terminalleri ile onaylanarak ürünün hareketleri anlık olarak izlenebilir. </p><p>• Sevkiyat süreç akış kuralına bağlı olarak, mobil el terminali üzerinde ürün toplama ve paketleme, oluşan paketlerin sevkiyatı, irsaliye ve faturalama işlemleri gerçekleştirilir. </p><p>• Mobil cihaz üzerinden ürün sorgulama yapılabilir. </p><h6>Raporlama</h6><p>Barkod Yazılımevi bambaşka bir raporlama aracı sunuyor. İnteraktif raporlama imkanı veren bu araç sayesinde raporlarınızı tasarlayın, kaydedin, tasarım kriterlerinizi tekrar tekrar kullanın. Ayrıca raporlarınızı tabloya alın, gruplayın ve ara toplamlar alın. Kısacası raporlama aracı ile raporlar üzerinde tam kontrol sağlayın. </p>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'39',
      'sKodu': 'KarpinKullanici',
      'sAciklama': 'Karpin Ek Kullanıcı',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 9950,
      'lFiyat2' : 9950,
      'lFiyat3' : 9950,
      'pResim' :require('@/assets/img/shop/39.png'),
      'sDetail' : 'Standart Paketlerde programı kullanacak Yeni kullanıcıların Lisanslaması bu satınalma ile yapılır. Satınalma esnasında Ekleme yapacağınız Firma Adresini seçmeyi unutmayınız.',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'40',
      'sKodu': 'KarpinUzaktanDestek',
      'sAciklama': 'Karpin Uzaktan Destek',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 700,
      'lFiyat2' : 700,
      'lFiyat3' : 700,
      'pResim' :require('@/assets/img/shop/40.png'),
      'sDetail' : 'Uzaktan Bilgisayar/larınıza bağlanarak sorunlarınızın çözülmesi için bu satınalmayı yapmanız gerekmektedir. Aynı gün için geçerlidir',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'41',
      'sKodu': 'KarpinYerindeDestek',
      'sAciklama': 'Karpin Yerinde Destek',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 1290,
      'lFiyat2' : 1290,
      'lFiyat3' : 1290,
      'pResim' :require('@/assets/img/shop/41.png'),
      'sDetail' : 'Uzaktan desteğin çözülemediği veya yerinde hizmet gerektiği durumlar için bu satınalmayı yapmanız gerekmektedir. Yol Masrafları size aittir. max 2 saat için geçerlidir. 2 Saati geçen durumlar için her 2 saat için aynı ücret geçerlidir.',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5
    },
    {
      'sFlash' :'',
      'nStokID':'53',
      'sKodu': 'KarpinAylikLisans',
      'sAciklama': 'Lisans Süresi 1 Ay Uzatma',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 499,
      'lFiyat2' : 499,
      'lFiyat3' : 499,
      'pResim' :require('@/assets/img/shop/43.png'),
      'sDetail' : ' Ücretsiz destek ilk 6 ay için geçerlidir. Yazılım destek hizmetinizi 1 Ay uzatarak Yeniliklerden faydalanabilir, değişikliklere adapte olabilirsiniz. Satınalma esnasında Adres ve Lisansı seçmeyi unutmayınız.',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'43',
      'sKodu': 'KarpinYillikLisans',
      'sAciklama': 'Lisans Süresi 1 Yıl Uzatma',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 1290,
      'lFiyat2' : 1290,
      'lFiyat3' : 1290,
      'pResim' :require('@/assets/img/shop/53.png'),
      'sDetail' : 'Ücretsiz destek ilk 6 ay için geçerlidir. Yazılım destek hizmetinizi 1 Yıl uzatarak Yeniliklerden faydalanabilir, değişikliklere adapte olabilirsiniz. Satınalma esnasında Adres ve Lisansı seçmeyi unutmayınız.',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'44',
      'sKodu': 'LisansTemizleme',
      'sAciklama': 'Lisans Bilgisi Temizleme',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 800,
      'lFiyat2' : 800,
      'lFiyat3' : 800,
      'pResim' :require('@/assets/img/shop/44.png'),
      'sDetail' : ' Lisanslı bilgisayarınızı değiştirmek istediğinizde bu satınalmayı yapmanız gerekmektedir. Satınalma esnasında adres ve lisans seçmeyi unutmayınız. ',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'51',
      'sKodu': 'LisansDurdur',
      'sAciklama': 'Lisans Durdurma',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 750,
      'lFiyat2' : 750,
      'lFiyat3' : 750,
      'pResim' :require('@/assets/img/shop/51.png'),
      'sDetail' : ' Lisanslı bilgisayarınızı değiştirmek istediğinizde bu satınalmayı yapmanız gerekmektedir. Satınalma esnasında adres ve lisans seçmeyi unutmayınız. ',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'52',
      'sKodu': 'LisansBilgisayar',
      'sAciklama': 'Lisans Bilgisayarı Bildir',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 950,
      'lFiyat2' : 950,
      'lFiyat3' : 950,
      'pResim' :require('@/assets/img/shop/52.png'),
      'sDetail' : 'Lisans bilgisayarını bildirmek istediğinizde bu satınalmayı yapmanız gerekmektedir. Satınalma esnasında adres ve lisans seçmeyi unutmayınız.',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'45',
      'sKodu': 'DestekAylik',
      'sAciklama': 'Aylık Destek Hizmeti',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 4990,
      'lFiyat2' : 4990,
      'lFiyat3' : 4990,
      'pResim' :require('@/assets/img/shop/45.png'),
      'sDetail' : ' Ücretsiz bakım-destek hizmeti için bu satınalmayı yapmanız gerekmektedir.(1 AY)',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    },
    {
      'sFlash' :'',
      'nStokID':'49',
      'sKodu': 'TabletPos',
      'sAciklama': 'Karpin IOS ve Android Tablet Uygulaması',
      'sSinifKodu' : 'software',
      'sDovizCinsi' :'TRL',
      'nKdvOrani' : 18,
      'lEskiFiyat' :'',
      'lFiyat1' : 19995,
      'lFiyat2' : 19995,
      'lFiyat3' : 19995,
      'pResim' :require('@/assets/img/shop/49.png'),
      'sDetail' : '<h6> <span>Yeni Nesil Tablet Çözümü</span> </h6><p>Hızlı ve kullanımı kolay, dokunmatik ekran destekli satış ekranı yardımıyla zamandan tasarruf sağlayan Karpin Perakende ile personelin tek tuşla satış, iade, kampanya, servis ve raporlama gibi her bir uygulamayı aynı ekrandan yönetebilmesi sağlanır. Arka ofis uygulamalarıyla ise taksitli satış ve vade farkı, mağaza performans raporlamaları, analiz, mal kabul ve onaylama, banka ve kasa işlemleri pratik bir şekilde gerçekleştirilebilir.</p><p>Dokunmatik Ekran Üzerinden, Peşin ve Açık Hesaba Satış Yapma, Satış Bekletme, Kolay Menü,Sanal Klavye, Fiş Yazdırma, Fatura Yazdırma ve Yazarkasadan fiş kesme.Teraziden Bilgi alma ve Tartılı ürün satışı.Menüden Satış, Tutara görme Miktar hesaplama,İskonto yapma , ikram verme. Puan ve Promosyon.Değişik Ödeme Türlerine göre Tahsilat yapma ve Veresiye yapma. Paraüstü Takibi ve Parçalı Tahsilat,Satıcı Takibi , Masa Takibi Veresiyeden tahsilat ve daha nice işlem ve raporlar </p><h6>Raporlama</h6><p>Barkod Yazılımevi bambaşka bir raporlama aracı sunuyor. İnteraktif raporlama imkanı veren bu araç sayesinde raporlarınızı tasarlayın, kaydedin, tasarım kriterlerinizi tekrar tekrar kullanın. Ayrıca raporlarınızı tabloya alın, gruplayın ve ara toplamlar alın. Kısacası raporlama aracı ile raporlar üzerinde tam kontrol sağlayın. </p>',
      'sStar' : 'Diamond',
      'bPopular' : false,
      'bAktif' : true,
      'rating': 5,
      'free_shipping':true
    }
  
  ];